import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import axiosInstance from './../axiosInstance.js';
import { Title } from '@mantine/core';
import ArtForm, { defaultFormState, proposalToFormState } from './ArtForm';

const CreateArt = () => {
  const location = useLocation();
  const proposal = location.state?.proposal;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const [form, setForm] = useState(proposal ? proposalToFormState(proposal) : defaultFormState);
  const setField = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const payload = {
        ...form,
        category: parseInt(form.category, 10),
        year: form.year || 0,
        duration: form.duration || 0,
      };
      const res = await axiosInstance.post('/createArt', payload);
      setSuccess(`Art created with ID: ${res.data.id}`);
    } catch (err) {
      setError(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-4">
      <Title order={2} mb="lg">Create Art{proposal ? ' (from proposal)' : ''}</Title>
      <ArtForm
        form={form}
        setField={setField}
        onSubmit={handleSubmit}
        loading={loading}
        error={error}
        success={success}
        submitLabel="Create Art"
        requireWikiLink
      />
    </div>
  );
};

export default CreateArt;
